import { toast } from "react-toastify";
import {
  getResolvedZebraErrorMessage,
  printZebraZpl,
} from "./zebraBrowserPrint";

export const ZebraMultiPrint = async (content: any) => {
  if (!Array.isArray(content) || content.length === 0) {
    return;
  }
  try {
    for (const item of content) {
      await printZebraZpl(`${item}`);
    }
  } catch (error) {
    toast.error(getResolvedZebraErrorMessage(error));
  }
};
